<template>
<div class="popup" v-cloak v-if="upgradeShow">
    <div class="content" id="upgradeAccount" ref="upBox">
        <div class="title">
            {{$t('language.popup.upgradeAccountPopup.upgradeAccount')}}
            <div class="icon white-close dialog-close" @click="upgradeShow=false"></div>
        </div>
        <div class="upgrade-content">
             <div v-if="remoteShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.upgradeHeadTitle')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.upgradeHeadContent')}}</div>
            </div>
            <div v-if="trafficShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.insufficientTraffic')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.insufficientTrafficDes')}}</div>
            </div>
            <div v-if="filterShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.filter')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.filterDes')}}</div>
            </div>
            <div v-if="modesShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title" ><b>{{$t('language.popup.upgradeAccountPopup.modes')}}</b></div>
                <div class="upgradeTxt-des" ref="txtTitle">{{$t('language.popup.upgradeAccountPopup.modesDes')}}</div>
            </div>
            <div v-if="doubleSyncShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.doubledSync')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.doubleSyncDes')}}</div>
            </div>
            <div v-if="syncMultShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.multipleSync')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.multipleSyncDes')}}</div>
            </div>
            <div v-if="accountsShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.subAccountPopup.titleMax')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.subAccountPopup.titleDes')}}</div>
            </div>
            <div v-if="subtaskShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.teamTransfer.subTaskLimit')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.teamTransfer.freeUsers')}}</div>
            </div>
             <div v-if="doubleRealTimeShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.doubleRealTime')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.doubleRealTimeSyncDes')}}</div>
            </div>
            <div v-if="scheduledShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.scheduled')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.scheduledDes')}}</div>
            </div>
            <div v-if="emailShow" style="margin-top:15Px;">
                <div class="upgradeTxt-title"><b>{{$t('language.popup.upgradeAccountPopup.emailTitle')}}</b></div>
                <div class="upgradeTxt-des">{{$t('language.popup.upgradeAccountPopup.emailDes')}}</div>
            </div>
            <div class="upgrade-form">
                <div class="form-des form-one">
                    <div class="plan-title title-one">{{$t('language.popup.upgradeAccountPopup.free')}}</div>
                    <div class="plan-line-all">
                        <div class="plan-line" v-for="(item, index) in freeItems" :key="index">
                            <div class="icon-util plan-check icon-check-position">
                            </div>
                            <span class="item-txt" :title="item">{{item}}</span>
                        </div>
                    </div>
                    <div class="plan-bottom">
                        <button class="plan-one-button">{{$t('language.popup.upgradeAccountPopup.currentPlan')}}</button>
                    </div>
                </div>
                <div class="form-des form-two">
                    <div class="plan-title title-two">{{$t('language.popup.upgradeAccountPopup.premium')}}</div>
                    <div class="plan-line-all">
                        <div class="plan-line" v-for="(item, index) in PremiumItmes" :key="index">
                            <div class="icon-util plan-check icon-check-position">
                            </div>
                            <span class="item-txt-right" :title="item">{{item}}</span>
                            <div class="icon-util  plan-question" style="position:relative;top:2Px;" v-if="indexArr.includes(index)">
                                <div class="plan-questionTxt" v-if="index==2">{{PremiumTextArr[0]}}</div>
                                <div class="plan-questionTxt" v-if="index==7">{{PremiumTextArr[1]}}</div>
                                <div class="plan-questionTxt" v-if="index==8">{{PremiumTextArr[2]}}</div>
                                <div class="plan-questionTxt" v-if="index==9">{{PremiumTextArr[3]}}</div>
                                <div class="plan-questionTxt" v-if="index==10">{{PremiumTextArr[4]}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="plan-bottom">
                        <button class="plan-two-button" @click="switchToPay()">{{$t('language.rightTopBanner.upgrade')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import googleAnalyticsUtil from "../../../js/workspace/google_analytics_util.js";
export default {
    data: function () {
        return {
            upgradeShow: false,
            freeItems: [this.$t('language.popup.upgradeAccountPopup.monthTraffic'), this.$t('language.popup.upgradeAccountPopup.emailsConversions'),this.$t('language.popup.upgradeAccountPopup.syncMode'),this.$t('language.popup.upgradeAccountPopup.offlineFree'),this.$t('language.cloudSync.realSync'),this.$t('language.teamTransfer.mostTeamTransfer')],
            PremiumItmes: [this.$t('language.popup.upgradeAccountPopup.moreTraffic'), this.$t('language.popup.upgradeAccountPopup.emailsUn'),this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),  this.$t('language.popup.upgradeAccountPopup.offlinePremium'),this.$t('language.cloudSync.realSync'), this.$t('language.teamTransfer.substasksMost'), this.$t('language.popup.upgradeAccountPopup.scheduled'),this.$t('language.popup.upgradeAccountPopup.transferSpeed'),this.$t('language.popup.upgradeAccountPopup.realTimeSyncing'), this.$t('language.popup.upgradeAccountPopup.norMalSyncing'),this.$t('language.popup.upgradeAccountPopup.filter'), this.$t('language.popup.upgradeAccountPopup.transferServer'), this.$t('language.popup.upgradeAccountPopup.customerSupport')],
            realTimeItems:[this.$t('language.popup.upgradeAccountPopup.moreTraffic'), this.$t('language.popup.upgradeAccountPopup.emailsUn'),this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),  this.$t('language.popup.upgradeAccountPopup.offlinePremium'),this.$t('language.cloudSync.realSync'), this.$t('language.teamTransfer.substasksMost'), this.$t('language.popup.upgradeAccountPopup.scheduled'),this.$t('language.popup.upgradeAccountPopup.transferSpeed'), this.$t('language.popup.upgradeAccountPopup.realTimeSyncing'), this.$t('language.popup.upgradeAccountPopup.norMalSyncing'),this.$t('language.popup.upgradeAccountPopup.filter'), this.$t('language.popup.upgradeAccountPopup.transferServer'), this.$t('language.popup.upgradeAccountPopup.customerSupport')],
            indexArr: [2, 7,8,9,10],
            PremiumTextArr: [this.$t('language.popup.upgradeAccountPopup.syncSupported'),
                this.$t('language.popup.upgradeAccountPopup.greatlyIncreased'),
                this.$t('language.popup.upgradeAccountPopup.sameTime'),
                 this.$t('language.popup.upgradeAccountPopup.normalSametime'),
                this.$t('language.popup.upgradeAccountPopup.automatically'),
            ],
            trafficShow: false,
            filterShow: false,
            modesShow: false,
            doubleSyncShow: false,
            syncMultShow: false,
            remoteShow:false,
            accountsShow:false,
            doubleRealTimeShow:false,
            subtaskShow:false,
            scheduledShow:false,
            emailShow:false,
        }
    },
    methods: {
        reset() {
            this.trafficShow = false;
            this.filterShow = false;
            this.modesShow = false;
            this.doubleSyncShow = false;
            this.syncMultShow = false;
            this.remoteShow=false;
            this.accountsShow=false;
            this.doubleRealTimeShow=false;
            this.subtaskShow=false;
            this.scheduledShow=false;
            this.emailShow=false;
        },
        switchToPay() {
          if(this.trafficShow){
            googleAnalyticsUtil.pay1(this, "traffic");
          }
          if(this.filterShow){
            googleAnalyticsUtil.pay1(this, "filter");
          }
          if(this.modesShow){
            googleAnalyticsUtil.pay1(this, "syncmodes");
          }
          if(this.doubleSyncShow){
            googleAnalyticsUtil.pay1(this, "double");
          }
          if(this.syncMultShow){
            googleAnalyticsUtil.pay1(this, "multisync");
          }
          if(this.remoteShow){
            googleAnalyticsUtil.pay1(this, "remote");
          }
          if(this.subtaskShow){
            googleAnalyticsUtil.pay1(this, "subtasks");
          }
          if(this.scheduledShow){
            googleAnalyticsUtil.pay1(this, "schedule");
          }
          if(this.accountsShow){
              this.$parent.addUserSubAccountShow=false;
              this.$parent.$parent.subAccountShow=false;
              this.upgradeShow=false;
              this.accountsShow=false;
          }
            commonUtils.switchToPay();
        }
    }
}
</script>

<style>
#upgradeAccount {
    width: 680Px;
    height: 660Px;
}

.upgrade-content {
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 0 15Px 15Px 15Px;
}

.upgradeTxt-title {
    color: #000;
    font-size: 14Px;
    line-height: 20Px;
    float: left;
    width: 100%;
    position: relative;
    left: 5Px;
}

.upgradeTxt-des {
    font-size: 14px;
    /*no*/
    color: #6f7886;
    float: left;
    line-height: 20px;
    /*no*/
    position: relative;
     top: 8Px;
    left: 5Px;
}

.upgrade-form {
    width: 100%;
    height: 440Px;
    float: left;
    margin-top: 20Px;
}

.form-des {
    float: left;
    width: 290Px;
    height: 500Px;
    box-shadow: 1px 1px 5px 1px #bababa;
    /*no*/
}

.form-two {
    margin-left: 35Px;
}

.form-one {
    margin-left: 15Px;
}

.plan-title {
    width: 100%;
    height: 45Px;
    float: left;
    text-align: center;
    font-size: 16Px;
    font-weight: bold;
    line-height: 45Px;
    color: #323b4c;
}

.title-one {
    background-color: #f1f1f1;
}

.title-two {
    background-color: #ffe6d2;
}

.plan-line-all {
    width: 100%;
    height: 400Px;
    box-sizing: border-box;
    padding: 15Px 0Px 5Px 20Px;
    font-size: 14Px;
    float: left;
}

.plan-line {
    width: 100%;
    float: left;
    height: 30Px;
}

.plan-bottom {
    width: 100%;
    height: 45Px;
    float: left;
    position: relative;
}

.form-des button {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.plan-one-button,
.plan-one-button:hover {
    border: 1Px solid #cdddf5;
    background-color: #fff;
    color: #6f7886;
    cursor: auto;
    width: 120Px;
}

.plan-question:hover .plan-questionTxt {
    display: block;
}

.plan-questionTxt {
    display: none;
    position: absolute;
    width: 250Px;
    border: 1Px solid #5562b4;
    border-radius: 3Px;
    left: 20Px;
    top: 2Px;
    background: #fff;
    z-index: 3;
    font-size: 12Px;
    box-sizing: border-box;
    padding: 5Px;
    line-height: 20Px;
}


.upgrade-head-content{
	font-size: 7px;
	color: dimgrey;
	margin-top: 3px;
}
.upgrade-head-title{
	margin:3px 0;
	font-size: 7px;
	font-weight: bold;
}
.upgrade-head{
	margin: 5px 0 0 22px;
}

.item-txt {
    float: left;
    max-width: 230Px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.item-txt-right {
    float: left;
    max-width: 220Px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}


</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/upgrade_account_popup.vue